
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-15463.6 16596.4 16.199 16.199"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Symbol_191_2","data-name":"Symbol 191 – 2","transform":"translate(-16024 16374)","opacity":".54"}},[_c('g',{attrs:{"id":"Group_8271","data-name":"Group 8271","transform":"translate(1 1)"}},[_c('circle',{staticClass:"cls-2",attrs:{"id":"Ellipse_952","cx":"7.5","cy":"7.5","r":"7.5","data-name":"Ellipse 952","transform":"translate(560 222)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Path_3655","d":"M5.1 5.623l2.273 2.386L10.441 4.6","data-name":"Path 3655","transform":"translate(560.014 221.946)"}}),_c('g',{attrs:{"id":"Group_8270","data-name":"Group 8270","transform":"translate(561.819 223.819)"}},[_c('path',{staticClass:"cls-2",attrs:{"id":"Line_1852","d":"M0 0h1.023","data-name":"Line 1852","transform":"translate(10.455 5.682)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Line_1853","d":"M0 0h1.023","data-name":"Line 1853","transform":"translate(0 5.682)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Line_1854","d":"M0 0v1.023","data-name":"Line 1854","transform":"translate(5.682 10.455)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Line_1855","d":"M0 0v1.023","data-name":"Line 1855","transform":"translate(5.682)"}})]),_c('circle',{attrs:{"id":"Ellipse_953","cx":"1.136","cy":"1.136","r":"1.136","data-name":"Ellipse 953","transform":"translate(566.25 228.705)","fill":"#444"}})])])])
          )
        }
      }
    